import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    blockStep0Legend: 'Vil du sperre kortet ditt midlertidig eller permanent?',
    blockStep0Description:
        'Hvis du sperrer kortet ditt midlertidig kan det gjenåpnes når som helst. Hvis kortet ditt virkerlig er borte er det viktig at vi sperrer kortet helt.',
    blockSoftTitle: 'Sperr kortet midlertidig',
    blockHardTitle: 'Sperr kortet permanent',
    terminateAccountTitle: 'Avslutt kontoen',
    formNext: 'Neste',
    formCancel: 'Avbryt',
};

export default fallbackDictionary;
